import axios from "@/libs/api.request.js";

// 获取OPEN ID/用户接口
export const getUser = data => axios.request({ url: "/user", data });

// 绑定用户接口
export const bind = data => axios.request({ url: "/bind", data });

// 解绑用户接口
export const remove = data => axios.request({ url: "/remove", data });

// 游戏列表接口
export const game = data => axios.request({ url: "/game", data });

// 角色列表接口
export const role = data => axios.request({ url: "/role", data });

// 获取角色红包状态接口
export const packetsStatus = data => axios.request({ url: "/packetsStatus", data });

// 领取红包接口
export const apply = data => axios.request({ url: "/apply", data });